import { UserModel } from "@/model/user/userModel";

export function ConvertToUserModel(userInfo: any): UserModel {
  /* eslint-disable @typescript-eslint/camelcase */
  const userModel: UserModel = {
    userId: userInfo.id,
    displayName: userInfo.given_name,
    lastLogInDateTime: userInfo.lastLogInDateTime,
    registerDateTime: userInfo.registerDateTime,
    phone: userInfo.phone_number,
    pictureUrl: userInfo.picture,
    signatureUrl: userInfo.signatureUrl,
    userEmail: userInfo.userEmail,
  };

  return userModel;
}
